import React from "react";
import AlignSelector from "./AlignSelector";

function HAlignment({canvas}) {
  const currentElement= canvas.current?.getActiveObject();

  return (
    <AlignSelector
      canvas={canvas}
      object={currentElement}
      property="textAlign"
      buttonText="HAlignSelector"
    />
  );
}

export default HAlignment;